module.exports = {
  name: 'CRM HOTEL',
  footerText: 'CRM HOTEL All Rights Reserved 2017',
  logoSrc: 'assets/img/logo.png',
  logoText: 'CRM HOTEL',
  needLogin: true,
  externalUrl: 'https://factura.triehotels.com/',
  slug: 'crmhotel',
  api: 'https://api2.estateprocrm.com/parse-server/crmhotel/',
  appId: 'UFK0LhDfvSuuy9VyymiItepF6FFitduXGQhnCXdo',
  apiKey: 'N8mrsBgXicrrXbbMkmGjHFxxwiQwNMYhWazzQkxh',
  masterKey: '1RjLD815pz2UgsjNxXXhPR7nTjim0XyivW6p43uB'
}



// WEBPACK FOOTER //
// ./src/utils/config.js